import { connect } from 'react-redux'
import { bindActionCreators, Dispatch } from 'redux'

import { IState } from '../../redux/state'
import { App as AppComponent } from './App'
import { PropsFromDispatch, PropsFromState } from './props'

const mapStateToProps = (state: IState): PropsFromState => {
  const { isDetailViewVisible, isSmallScreen } = state.ui.detailView

  return {
    inMobileDetailView: isDetailViewVisible && isSmallScreen,
  }
}

const mapDispatchToProps = (dispatch: Dispatch): PropsFromDispatch => {
  return bindActionCreators({}, dispatch)
}

// tslint:disable-next-line:variable-name
export const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent)
